import MiModal from './modal';
import { install } from '../../utils/install';
export default install(MiModal, '$modal');
